import React from 'react';
import FormType, { FieldConfigs } from '../../../../shared/components/FormType';
import { UserFormWrapper } from '../../detail/Content/Styled';
import { EmployeeRolesDropdown } from '../../../../configs/employee';
import { useState } from 'react';

interface FormContainerProps {
    validated: boolean;
    requiredData: any;
    mergeUser: Function;
}

const FormContainer = ({ validated, requiredData, mergeUser }: FormContainerProps) => {
    const [fields, setFields] = useState<FieldConfigs[]>([
        {
            label: 'Trạng thái',
            type: 'toggle',
            key: 'is_active',
        },
        {
            label: 'Mã nhân viên',
            type: 'text',
            key: 'user_code',
            required: true,
        },
        {
            label: 'Họ và tên',
            type: 'text',
            key: 'display_name',
            required: true,
        },
        {
            label: 'Số điện thoại',
            type: 'text',
            key: 'phone_number',
            required: true,
            validation: 'phone',
        },
        {
            label: 'Email',
            type: 'text',
            key: 'email',
            required: true,
            validation: 'email',
        },
        {
            label: 'Vai trò',
            type: 'dropdown',
            key: 'role',
            required: true,
            showPlaceholder: true,
            options: EmployeeRolesDropdown,
        },
        {
            label: 'Username',
            type: 'text',
            key: 'username',
            required: true,
        },
        {
            label: 'Mật khẩu',
            type: 'text',
            key: 'password',
            required: true,
            hideToggleText: false,
        },
        {
            label: 'Xác nhận mật khẩu',
            type: 'text',
            key: 'confirm_password',
            required: true,
            hideToggleText: false,
        },
    ]);

    const handleChangeUser = (updateUserContact: any) => {
        const updateUser = {
            ...updateUserContact,
            username: updateUserContact.username,
            display_name: updateUserContact.display_name,
            phone_number: updateUserContact.phone_number,
            email: updateUserContact.email,
            user_code: updateUserContact.user_code,
        };
        mergeUser(updateUser);
    };

    return (
        <UserFormWrapper>
            <FormType
                title={'Thông tin tài khoản'}
                fields={fields}
                validated={validated}
                requireData={requiredData}
                mergeFormData={handleChangeUser}
                setFields={setFields}
            />
        </UserFormWrapper>
    );
};

export default FormContainer;
